import {Button, Stack, Typography, useMediaQuery} from '@mui/material'
import { format as dateFnsFormat } from 'date-fns/format'
import { useTranslation } from 'react-i18next'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import {useWrapperStore} from "../../store/storeWrapper";
import {theme} from "../../theme";
import { getDateFnsLocale } from '../../utils/dateLocale'

export const AssistantDisconnectDialog = ({ open, handleClose, handleSubmit, assistant }) => {
    const { t, i18n } = useTranslation()
    const { removeAssistantSubscription, fetchAssistantSubscriptions,  } = useWrapperStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const handleClickSubmit = async () => {
        await removeAssistantSubscription(assistant.id)
        await fetchAssistantSubscriptions()
        await handleClose()
    }
    return (
        <ModalDialogWrapper
            footerActions={
                <Stack
                    direction={isMobile ? 'column' : 'row'}
                    spacing={1}
                    sx={{ width: '100%'  }}>
                    <Button variant="outlined" fullWidth onClick={handleClickSubmit }>
                        {t('finances.cancel')}
                    </Button>
                    <Button variant="contained" onClick={handleClose} fullWidth>
                        {t('finances.keepSubscription')}
                    </Button>
                </Stack>
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={t('finances.cancelSubscriptionTitle', { name: assistant?.assistant_name })}>
            <Typography>
                {t('finances.cancelSubscriptionText', {
                    date: assistant?.end_at && dateFnsFormat(assistant?.end_at, 'd MMMM yyyy', {
                        locale: getDateFnsLocale(i18n.language),
                    })
                })}
            </Typography>
        </ModalDialogWrapper>
    )
}
